export default __webpack_public_path__ + "static/media/csvFileIcon.6dd837d1.svg";